<template lang="pug">
a.btn.btn-icon.btn-naked(
  v-tooltip
  data-placement="top"
  data-original-title="View all notes"
  @click="showAllNotesDialog"
)
  i.hi.hi-16.hi-blog
</template>

<script>
export default {
  name: 'ActivitiesNotesButton',
  props: {
    userId: {
      type: [String, Number],
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    projectId: {
      type: [String, Number],
      required: false,
    },
    currentZone: {
      type: Object,
      required: true,
    },
  },
  methods: {
    showAllNotesDialog() {
      const queryProjectId = this.projectId ? `&filter_project_id=${this.projectId}` : '';
      const urlParams =
        `?user_id=${this.userId}&organization_id=${this.organizationId}` +
        `&date=${this.date}${queryProjectId}&time_zone=${encodeURIComponent(this.currentZone.name)}`;

      AjaxDialog.run(`/notes.dialog${urlParams}`);
    },
  },
};
</script>
